import React from 'react'
import { connect } from 'react-redux'
import { selectHome } from '../../store/site'

import Head from '../../components/utils/Head'
import SliceProcessor from '../../components/utils/SliceProcessor'
import Theme from '../../components/utils/Theme'

const Home = ({
  home
}) => (
  <Theme>
    <div>
      <Head />
      <SliceProcessor slices={home} />
    </div>
  </Theme>
)

const mapState = (store) => ({
  home: selectHome(store)
})

export default connect(mapState)(Home)



// WEBPACK FOOTER //
// ./routes/Home/index.js